import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-show-file-from-url',
  templateUrl: './show-file-from-url.component.html',
  styleUrls: ['./show-file-from-url.component.css']
})
export class ShowFileFromUrlComponent {
  filename = "download.pdf"
  constructor(
    public dialogRef: MatDialogRef<ShowFileFromUrlComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
export interface DialogData {
  url: any,
  refdocURL?: string,
  refdocURL2?: string,
  DocumentName?: string
}